import React from 'react';

export const assetKategoriTable = (handleEdit, handleDelete) => {
    return [
        {
            title: "id_asset_kategori",
            render: rowData => {
                return <span>{rowData.id_asset_kategori}</span>
            }
        },
        {
            title: "Asset Kategori",
            render: rowData => {
                return <span>{rowData.asset_kategori}</span>
            }
        },
        {
            title: "Created At",
            render: rowData => {
                return <span>{rowData.created_at}</span>
            }
        },
        {
            title: "Updated At",
            render: rowData => {
                return <span>{rowData.updated_at}</span>
            }
        },
        {
            title : "Action",
            render : rowData => {
                return (
                    <>
                        <button 
                            className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
                            onClick={(e) => handleEdit(rowData)}
                        >
                        Edit
                        </button>
                        <button
                            className='bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded'
                            onClick={(e) => handleDelete(rowData)}
                        >
                        Delete
                        </button>
                    </>
                )
            }
        }

    ]
}